var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersIconVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 7.70417 2.69334 5.45417 3.065 3.26417C3.14 2.82 3.52834 2.5 3.97834 2.5L4.84834 2.5C5.09456 2.5 5.33838 2.54849 5.56587 2.64272C5.79336 2.73695 6.00006 2.87506 6.17417 3.04917L10.7008 7.57583C10.8749 7.74994 11.0816 7.88805 11.3091 7.98228C11.5366 8.07651 11.7804 8.125 12.0267 8.125L14.4658 8.125C14.8141 8.12493 15.1556 8.22189 15.4519 8.40499C15.7482 8.5881 15.9876 8.85011 16.1433 9.16167L17.5 11.875L12.0267 11.875C11.7804 11.875 11.5366 11.9235 11.3091 12.0177C11.0816 12.1119 10.8749 12.2501 10.7008 12.4242L6.17417 16.9508C6.00006 17.1249 5.79336 17.2631 5.56587 17.3573C5.33838 17.4515 5.09457 17.5 4.84834 17.5L3.97834 17.5C3.52834 17.5 3.14 17.18 3.065 16.7358C2.68821 14.5104 2.49921 12.2571 2.5 10Z",
    stroke: "#4B4F5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIconVertical);
export default __webpack_public_path__ + "static/media/filters-icon-vertical.439cc27a51c4463e9d64a792101d0b82.svg";
export { ForwardRef as ReactComponent };